import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { get } from '@front/common/src/api/requester';
import { UNIVERSES } from '@front/common/src/constants/universes';
import type { UniverseReference } from '@front/common/src/types/commons';

const CESU_WALLET_QUERY_KEY = 'cesu_wallet';

type CesuWalletResponse = {
  // Amount in the user's e-CESU wallet, in cents.
  // null when the universe is not eligible, 0 when the wallet is empty or absent.
  cesu_amount: number | null;
};

type GetCesuWalletParams = Pick<UseQueryOptions<CesuWalletResponse>, 'enabled'> & {
  universe?: UniverseReference;
};

export const useGetCesuWalletQuery = ({ enabled = true, universe = UNIVERSES.CLEANING }: GetCesuWalletParams = {}) => {
  const {
    data,
    isLoading: isLoadingCesuAmount,
    error: cesuAmountError,
  } = useQuery<CesuWalletResponse, Error>({
    queryKey: [CESU_WALLET_QUERY_KEY, universe],
    queryFn: async () => {
      const response = await get('/customer/cesu_wallet', { query: { universe } });
      return response.data;
    },
    enabled,
  });

  return { cesuAmount: data?.cesu_amount, isLoadingCesuAmount, cesuAmountError };
};
